export default __webpack_public_path__ + "static/noi2020silver-d4259ea654b1fea79d91a5b5bb3d8b3b.jpg";